export default __webpack_public_path__ + "static/media/checkmark-checked.5d061532.svg";